<div class="question-group-container">
  <ng-container *ngIf="version2Form; else originalSection">
    <div class="row">
      <formly-field *ngFor="let step of field.fieldGroup; let index = index; let last = last" [field]="step"></formly-field>
    </div>
  </ng-container>
  <ng-template #originalSection>
    <div
    *ngFor="let step of field.fieldGroup; let index = index; let last = last"
    class="form-section"
    [ngClass]="{ 'form-section-table': to.isTable }"
  >
    <formly-field [field]="step"></formly-field>
  </div>
  </ng-template>
</div>
